import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'reactstrap';
import TopNav from '../../../components/TopNav';
import './GrowBusiness.scss';

class GrowBusiness extends React.Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    originalOrgId: PropTypes.string,
    orgInfo: PropTypes.object,
    newMessage: PropTypes.bool.isRequired,
    newMessageCount: PropTypes.number.isRequired,
    canSeeMessageCenter: PropTypes.bool,
  };

  static defaultProps = {
    originalOrgId: null,
    orgInfo: null,
    canSeeMessageCenter: false,
  };

  componentDidMount() {
    window.scrollTo({ top: 0 });
  }

  render() {
    const { login, logout, auth, originalOrgId, orgInfo, newMessage, newMessageCount, canSeeMessageCenter } = this.props;

    return (
      <div className="grow-business-page">
        <Helmet>
          <title>NFFS ICON - Grow Your Business</title>
          <meta name="description" content="ICON's tailored bid matching allows users to set up customizable settings to receive daily email notifications of open solicitations that perfectly align with your foundry's materials, processes, and specialization." />
        </Helmet>

        <TopNav
          login={login}
          logout={logout}
          auth={auth}
          originalOrgId={originalOrgId}
          orgInfo={orgInfo}
          newMessage={newMessage}
          newMessageCount={newMessageCount}
          canSeeMessageCenter={canSeeMessageCenter}
        />

        <Container className="content-container mt-5 mb-5">
          <Row>
            <Col>
              <h1 className="page-title mb-4">Grow Your Business</h1>
              
              <div className="intro-card mb-4">
                <h2>ICON&apos;s Tailored Bid Matching</h2>
                <p className="lead">
                  ICON&apos;s tailored bid matching allows users to set up customizable settings within the portal to receive daily email notifications of open solicitations that perfectly align with your foundry&apos;s materials, processes, and specialization. This saves valuable time that would otherwise be spent sifting through irrelevant opportunities. By actively engaging with the features and functionalities of ICON, foundries can effectively position themselves within the defense casting market, secure new contracts, and become an approved source for future contracts with DOD.
                </p>
              </div>

              <div className="features-card">
                <h3 className="features-title">Key Features</h3>
                <div className="features-grid">
                  <div className="feature-item">
                    <div className="feature-icon"><span role="img" aria-label="Settings">⚙️</span></div>
                    <div className="feature-content">
                      <h4>Customized Bid Match Settings</h4>
                      <p>Tailor your preferences to receive notifications that match your specific capabilities</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon"><span role="img" aria-label="Email">📧</span></div>
                    <div className="feature-content">
                      <h4>Daily Email Notifications</h4>
                      <p>Get daily emails highlighting opportunities that match your business strengths</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon"><span role="img" aria-label="Document">📋</span></div>
                    <div className="feature-content">
                      <h4>Technical Data Packages</h4>
                      <p>Explore specific details of part requirements, design and view technical data packages (drawings)</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon"><span role="img" aria-label="Search">🔍</span></div>
                    <div className="feature-content">
                      <h4>Advanced Filtering</h4>
                      <p>Filter opportunities by materials, processes, dimensions, and capabilities</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon"><span role="img" aria-label="Chart">📊</span></div>
                    <div className="feature-content">
                      <h4>Procurement History</h4>
                      <p>Access to full procurement history and estimated contract values</p>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon"><span role="img" aria-label="Link">🔗</span></div>
                    <div className="feature-content">
                      <h4>Direct Links</h4>
                      <p>Direct links to technical drawings and specifications</p>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default GrowBusiness;



// WEBPACK FOOTER //
// ./src/pages/static/GrowBusiness/GrowBusiness.jsx